module.exports = __webpack_public_path__ + "img/VI.0467cc0d.png";